<template>
  <div :id="content.id" class="container section">
    <div class="row">
      <div id="contactUsText" class="col-6" v-reveal>
        <h1>{{ content.title }}</h1>
        <p v-for="(text, index) in content.text" :key="index">{{ text }}</p>
        <p>Email: {{ content.email }}</p>
        <p>Phone: {{ content.phone }}</p>
        <p>{{ content.useForm }}</p>
      </div>

      <div v-if="success" class="col-6 center icon-col">
        <success-icon></success-icon>
        <h2 class="success-text">Email Sent</h2>
      </div>
      <div v-if="error" class="col-6 center">
        <error-icon></error-icon>
        <h2 class="error-text">Something went wrong</h2>
        <p class="error-text">
          Please try phoning or using the email address on the side within your
          own email client.
        </p>
      </div>

      <div v-if="!success && !error" class="col-6" v-reveal="100">
        <form id="emailForm" name="emailForm" method="post" @submit="onSubmit">

        <div class="honeypot" aria-hidden="true"> <label for="website">Website</label> <input id="website" type="text" name="website" v-model="form.website" tabindex="-1" autocomplete="off" /> </div>

          <div class="row">
            <div class="col-6">
              <input
                type="text"
                class="form-control"
                placeholder="First Name"
                required
                v-model="form.first"
              />
            </div>
            <div class="col-6">
              <input
                type="text"
                class="form-control"
                placeholder="Surname"
                required
                v-model="form.surname"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <input
                type="email"
                class="form-control"
                placeholder="Email Address"
                required
                v-model="form.email"
              />
            </div>
            <div class="col-6">
              <input
                type="text"
                class="form-control"
                placeholder="Where do you live?"
                required
                v-model="form.live"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                placeholder="How did you hear about us?"
                required
                v-model="form.hear"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                placeholder="Subject"
                required
                v-model="form.subject"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <textarea
                class="form-control"
                rows="8"
                name="content"
                v-model="form.content"
              ></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-12 center">
              <button class="btn btn-primary" id="sendEmail">Send</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SuccessIcon from "./SuccessIcon.vue";
import ErrorIcon from "./ErrorIcon.vue";

const querystring = require("querystring");

export default {
  props: {
    content: Object,
  },
  components: {
    "success-icon": SuccessIcon,
    "error-icon": ErrorIcon,
  },
  data() {
    return {
      success: false,
      error: false,
      form: {
        first: "",
        surname: "",
        email: "",
        live: "",
        hear: "",
        where: "",
        content: "",
        website: "",
      },
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      axios
        .post("/api/email", querystring.stringify(this.form))
        .then((result) => {
          this.success = result.data.success;
          if (!this.success) {
            this.error = true;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
  },
};
</script>

<style lang="scss">
@import "./../../variables.scss";

#emailForm {
  margin-top: $space-4;
}

#sendEmail {
  width: 100%;
}

@media only screen and (max-width: 1000px) {
  #contactUsText p,
  #contactUsText h1 {
    text-align: center;
  }
}

.error-text {
  color: red;
}

.success-text {
  color: #4cc93f;
}

.icon-col {
  padding-top: $space-12;
  padding-bottom: $space-12;
}

.honeypot { position: absolute; left: -9999px; width: 1px; height: 1px; overflow: hidden; }

.honeypot input { width: 1px; height: 1px; padding: 0; border: 0; }
</style>
